import { LucideProps } from 'lucide-react'

const Bar = (props: LucideProps) => (
  <svg
    viewBox="0 0 66 83"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="0.5" y="22.5" width="28.4821" height="60.1849" fill="#B5D5D8" />
    <rect x="36.9453" width="28.4821" height="82.6875" fill="#3D7CC9" />
  </svg>
)

export default Bar
